import * as PIXI from 'pixi.js'

import './style/styleManager'
import { Dimension } from '../layout/constants'
import createLayout from '../layout/layout'
import { createDefaultStyle } from '../style/parser'

const defaultStyle = createDefaultStyle()

const layoutItems = []
let root

const _layout = createLayout({
  getSize: (node, dimension) => {
    if (typeof node.getLayoutSize === 'function') {
      return node.getLayoutSize(dimension)
    }
    if (node instanceof PIXI.Graphics) {
      return node[dimension]
    }
    if (node instanceof PIXI.Text) {
      return node[dimension]
    }
    if (node instanceof PIXI.Sprite) {
      return node.texture[dimension]
    }
  },

  getChildren: (node) =>
    node.children.filter((e) => typeof e.name !== 'string' || !e.name.startsWith('$mudra.')),

  getPosition: (node, axis) => node[axis],

  getStyle: (node) => {
    return node.style || defaultStyle
  },

  setSize: (node, dimension, value) => {
    if (typeof node.setLayoutSize === 'function') {
      node.setLayoutSize(dimension, value)
      return
    }

    if (node instanceof PIXI.Sprite) {
      node[dimension] = value
    }
  },

  setPosition: (node, axis, value) => {
    if (node === root) {
      return
    }
    if (axis === 'x') {
      node.x = value
      return
    }
    node.y = value
  },

  customLayout: (node, layoutItem) => {
    if (typeof node.mudraLayout === 'function') {
      const width = layoutItem.getGivenBoxSize(Dimension.WIDTH)
      const height = layoutItem.getGivenBoxSize(Dimension.HEIGHT)
      return node.mudraLayout(layoutItem.style, width, height)
    }
  },

  cacheLayout: (node, layoutItem) => {
    layoutItems.push(layoutItem)
  },
})

export const layout = (node) => {
  layoutItems.length = 0
  root = node
  _layout(node)
  for (const item of layoutItems) {
    if (typeof item.node.onLayoutCompleted === 'function') {
      item.node.onLayoutCompleted(item)
    }
  }
}
